import { useState, useEffect } from 'react';
import { collection, query, where, onSnapshot, documentId } from 'firebase/firestore';
import { db } from '../config/firebase';
import type { CardMetadata } from '../types/card';

const COLLECTION = 'demo_portal_cards';

export function useCardMetadata(cardIds: string[]) {
  const [cards, setCards] = useState<CardMetadata[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (cardIds.length === 0) {
      setCards([]);
      return;
    }

    setLoading(true);

    // Firestore 'in' queries support max 30 items
    // For now, take first 30 (portal sections won't have more)
    const ids = cardIds.slice(0, 30);

    const q = query(
      collection(db, COLLECTION),
      where(documentId(), 'in', ids),
    );

    const unsubscribe = onSnapshot(
      q,
      (snap) => {
        const result = snap.docs.map(
          (d) => ({ id: d.id, ...d.data() } as CardMetadata),
        );
        setCards(result);
        setLoading(false);
      },
      (err) => {
        console.error('Card metadata subscription error:', err);
        setLoading(false);
      },
    );

    return unsubscribe;
  }, [JSON.stringify(cardIds)]);

  return { cards, loading };
}
